import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { motion } from "framer-motion";

import Tecnicos from "../../static/media/home/tecnicos.webp";
import AsesoriaIcon from "../../static/media/home/MayorMenor.webp";
import ProvicionIcon from "../../static/media/home/Cotizacion.webp";
import LogisticaIcon from "../../static/media/home/Soporte.webp";
import MaterialesIcon from "../../static/media/home/Luz.webp";

const C = {
  dark: "#0C1F2F",
  navy: "#0057A8",
  navyDark: "#003D73",
  gold: "#FFCD00",
  goldDark: "#E6B800",
  teal: "#5BC8AF",
  gray: "#F5F7FA",
  white: "#ffffff",
};

const SERVICES_DATA = [
  {
    id: 1,
    title: "Venta Mayor y Menor",
    description:
      "Atención a hogares y constructoras. Soluciones adaptables con precios altamente competitivos.",
    img: AsesoriaIcon,
    accentColor: C.gold,
  },
  {
    id: 2,
    title: "Cotización Rápida",
    description:
      "Cotiza por WhatsApp al instante. Agilizamos todos tus procesos de compra y logística.",
    img: ProvicionIcon,
    accentColor: C.teal,
  },
  {
    id: 3,
    title: "Soporte Post-venta",
    description:
      "Acompañamiento técnico continuo, cambios directos y gestión rápida de garantías de fábrica.",
    img: LogisticaIcon,
    accentColor: C.gold,
  },
  {
    id: 4,
    title: "Iluminación y Control",
    description:
      "Tecnología LED, tableros de distribución y protecciones para modernizar tus espacios.",
    img: MaterialesIcon,
    accentColor: C.teal,
  },
];

const container = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.1 } },
};
const item = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
};

export default function Services() {
  return (
    <Box
      id="servicios"
      sx={{
        background: `linear-gradient(180deg, ${C.navy} 0%, ${C.navyDark} 100%)`,
        pt: { xs: "64px", md: "88px" },
        pb: 0,
        overflow: "hidden",
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          maxWidth: "1280px",
          mx: "auto",
          width: "100%",
          px: { xs: "20px", sm: "32px", md: "40px" },
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
          alignItems: { xs: "center", lg: "center" },
          justifyContent: "space-between",
          gap: { xs: 5, lg: 6 },
          boxSizing: "border-box",
        }}
      >
        <Box
          component={motion.div}
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          sx={{
            width: { xs: "100%", sm: "85%", lg: "42%" },
            position: "relative",
            display: "flex",
            justifyContent: "center",
            mx: { xs: "auto", lg: 0 },
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "14px",
              left: "-14px",
              width: "100%",
              height: "100%",
              borderRadius: "24px",
              background: "rgba(255,205,0,0.15)",
              zIndex: 0,
            }}
          />
          <Box
            component="img"
            src={Tecnicos}
            alt="Técnicos ElectricaGRM"
            sx={{
              width: "100%",
              height: "auto",
              maxHeight: { xs: "300px", sm: "360px", lg: "440px" },
              objectFit: "cover",
              borderRadius: "20px",
              zIndex: 1,
              position: "relative",
              boxShadow: "0 20px 50px rgba(0,0,0,0.40)",
            }}
          />
          <Box
            sx={{
              position: "absolute",
              bottom: { xs: "-16px", lg: "24px" },
              right: { xs: "10px", lg: "-28px" },
              background: "rgba(255,255,255,0.97)",
              backdropFilter: "blur(8px)",
              p: "10px 14px",
              borderRadius: "14px",
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              zIndex: 2,
              boxShadow: "0 10px 30px rgba(0,0,0,0.22)",
            }}
          >
            <Box
              sx={{
                width: 34,
                height: 34,
                background: `${C.teal}28`,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke={C.navyDark}
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
            </Box>
            <Box>
              <Typography
                sx={{
                  color: C.dark,
                  fontWeight: 900,
                  fontSize: 12.5,
                  lineHeight: 1.2,
                }}
              >
                Soporte Experto
              </Typography>
              <Typography
                sx={{ color: "#5c6c7a", fontSize: 10.5, fontWeight: 600 }}
              >
                Asesoría 100% real
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            width: { xs: "100%", lg: "54%" },
            display: "flex",
            flexDirection: "column",
            mt: { xs: 4, lg: 0 },
          }}
        >
          <Box
            component={motion.div}
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            sx={{
              textAlign: { xs: "center", lg: "left" },
              mb: { xs: 3, md: 4 },
            }}
          >
            <Typography
              variant="h2"
              sx={{
                color: C.white,
                fontWeight: 900,
                fontSize: { xs: 26, sm: 32, md: 38 },
                letterSpacing: "-.02em",
                lineHeight: 1.1,
              }}
            >
              Nuestros Servicios
            </Typography>
          </Box>

          <Box
            component={motion.div}
            variants={container}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)" },
              gap: { xs: "14px", md: "18px" },
            }}
          >
            {SERVICES_DATA.map((service) => (
              <Box
                key={service.id}
                component={motion.div}
                variants={item}
                whileHover={{ y: -5, transition: { duration: 0.22 } }}
                sx={{
                  background: C.white,
                  borderRadius: "16px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: { xs: "center", sm: "flex-start" },
                  textAlign: { xs: "center", sm: "left" },
                  p: { xs: "18px 16px", md: "22px" },
                  position: "relative",
                  overflow: "hidden",
                  boxShadow: "0 4px 18px rgba(0,0,0,.14)",
                  transition: "box-shadow .25s",
                  "&:hover": { boxShadow: "0 16px 36px rgba(0,0,0,.22)" },
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    height: "3px",
                    background: service.accentColor,
                    transform: "scaleX(0.15)",
                    transition: "transform 0.3s ease",
                    transformOrigin: "left",
                  },
                  "&:hover::after": { transform: "scaleX(1)" },
                }}
              >
                <Box
                  sx={{
                    width: 56,
                    height: 56,
                    borderRadius: "12px",
                    background: `${service.accentColor}18`,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    p: 1,
                    mb: 1.6,
                    flexShrink: 0,
                  }}
                >
                  <Box
                    component="img"
                    src={service.img}
                    alt={service.title}
                    sx={{ width: "100%", height: "100%", objectFit: "contain" }}
                  />
                </Box>
                <Typography
                  sx={{
                    color: C.dark,
                    fontWeight: 800,
                    fontSize: { xs: 14.5, md: 15.5 },
                    mb: 0.6,
                    lineHeight: 1.25,
                    letterSpacing: "-.01em",
                  }}
                >
                  {service.title}
                </Typography>
                <Typography
                  sx={{
                    color: "#5c6c7a",
                    fontSize: { xs: 12, md: 13 },
                    lineHeight: 1.55,
                  }}
                >
                  {service.description}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>

      {/* Transición extendida hacia blanco */}
      <Box
        sx={{
          height: { xs: "120px", md: "180px" },
          background: `linear-gradient(180deg, ${C.navyDark} 0%, ${C.white} 100%)`,
          mt: { xs: 7, md: 10 },
        }}
      />
    </Box>
  );
}
